export { FileMinus as default } from './FileMinus';
